import { type FC, useCallback, useEffect, useMemo } from "react";
import { Loader } from "semantic-ui-react";

import "./reportingExport.scss";
import { Tooltip } from "components/common/tooltip";
import { connect, type ConnectedProps } from "react-redux";
import { type AppDispatch, type RootState } from "features/Application/globaltypes/redux";
import {
  selectExportInfo,
  selectExporting,
  selectExportTooltipContent,
  selectHasDataToExport,
  reset,
} from "features/Reporting/state/export/exportSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/pro-solid-svg-icons";
import { bindAction } from "interfaces";

export const ReportingExport: FC<PropsFromRedux> = ({
  exporting,
  exportInfo,
  tooltipContent,
  hasDataToExport,
  resetExport,
}) => {
  const isDisabled = useMemo(() => exporting || !hasDataToExport, [exporting, hasDataToExport]);

  const handleExport = useCallback(() => {
    exportInfo.method(...exportInfo.args);
  }, [exportInfo]);

  useEffect(() => {
    return () => {
      resetExport();
    };
  }, [resetExport]);

  return (
    <button className="reporting-export-button" onClick={handleExport} disabled={isDisabled} type="button">
      {exporting ? (
        <Loader active />
      ) : (
        <Tooltip
          target={
            <>
              <FontAwesomeIcon icon={faDownload} />
              <span>Export</span>
            </>
          }
          content={tooltipContent}
          position="left center"
          showAlways
          disabled={hasDataToExport}
        />
      )}
    </button>
  );
};

const mapStateToProps = (state: RootState) => ({
  tooltipContent: selectExportTooltipContent(state),
  hasDataToExport: selectHasDataToExport(state),
  exporting: selectExporting(state),
  exportInfo: selectExportInfo(state),
});

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    resetExport: bindAction(reset, dispatch),
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export const ConnectedComponent = connector(ReportingExport);
export default ConnectedComponent;
